import { createContext } from 'react';
export const DependencyInjectionContext = createContext(null);
